import type {ComposedFC} from '../helpers/react-helpers';
import { withClass, withDefaultProps} from '../helpers/react-helpers'
import type { RouteGetParams} from '../helpers/ajax';
import {resolveRoute} from '../helpers/ajax'
import Icon from './Icon'
import icons from '../../markons/markons'
import cn from 'classnames'
import {useTestId} from '../contexts/testid'

export const BaseLink: ComposedFC<'a', { disabled?: boolean, testId?: string }> = ({
    disabled,
    testId,
    onClick,
    href,
    className,
    ...props
}) => (
    <a data-testid={useTestId(testId)} {...props}
        className={cn(!!disabled && 'disabled', className)}
        onClick={!disabled ? onClick : undefined}
        href={!disabled ? href : undefined}
        aria-disabled={disabled || undefined} />
)

export const SafeLink = withDefaultProps(BaseLink, {rel: 'noreferrer'})
export const ExternalLink = withDefaultProps(SafeLink, {target: '_blank'})


export type InternalLinkProps = OverrideProps<typeof BaseLink, {
    route: string
    params?: RouteGetParams
}, 'href'>

export function InternalLink({route, params, ...props}: InternalLinkProps) {
    return <BaseLink
        rel="opener referrer"
        href={resolveRoute(route, params)} {...props} />
}

export const LinkButton = withClass(InternalLink, 'btn')

export const NewLinkButton: ComposedFC<typeof LinkButton> = ({children, className, ...props}) => (
    <LinkButton className={cn('btn-new', className)} {...props}><Icon name={icons.miscPlus} />{children}</LinkButton>
)

export type EmailLinkProps = OverrideProps<typeof BaseLink, { email?: string }>

export function EmailLink({email, ...props}: EmailLinkProps) {
    return <BaseLink
        {...props} href={email ? `mailto:${email}` : undefined}
    />
}

export type PhoneLinkProps = OverrideProps<typeof BaseLink, { phone?: string }>

export function PhoneLink({phone, ...props}: PhoneLinkProps) {
    return (
        <BaseLink
            {...props}
            href={phone ? `tel:${phone}` : undefined}
        />
    )
}
